import { useState, useEffect } from 'react';
import { api } from '../services/api';

export const useMovementCache = () => {
  const [cache, setCache] = useState({});

  useEffect(() => {
    const load = async () => {
      try {
        const movements = await api.getAllMovements();
        const map = {};
        console.log("from db",movements)
             const list = Array.isArray(movements)
        ? movements
        : Array.isArray(movements?.data)
        ? movements.data
        : [];

      list.forEach(m => {
        if (m?.DS5Mvt && m?.idmvt) {
          map[m.DS5Mvt] = m.idmvt;
        }
      });
        
        setCache(map);
      } catch (err) {
        console.warn("Cache mouvements non chargé, utilisant fallback",err);
        setCache({
          "Quick Drift": 1, 
          "Charging": 2, 
          "Full Test": 3, 
          "Cleaning and Polishing": 4,  
          "Grading and Quality Control": 5,
          "Packaging": 6,              
          "Quality Control": 7,                
          "Export": 8,               
          "Repair": 9,                
          "BER": 10,                
          "Repair Batterie /Boutton": 11,               
          "Repair Joystick": 12,                
          "Assemblage DS5": 13,
          
        });
      }
    };
    load();
  }, []);
  
  return cache;
};